import Component from '../component';

export default class BlockVideo extends Component {
	constructor(...args) {
		super(...args);

		this._params = {
			type: null,
			id: null
		};
		
		this.retrieveDom();
		if (this.dom.component.classList.contains('is-vimeo')) {
			this.initVimeo();
		} else {
			this.initYoutube();
		}
	}

	retrieveDom() {
		this.dom.video = this.dom.component.querySelector('.js-player');
		this.dom.poster = this.dom.component.querySelector('.js-poster');
		this.dom.about = this.dom.component.querySelector('.js-about');
		this.dom.buttonPlay = this.dom.component.querySelector('.js-play');
		
		this._params.id = this.dom.component.getAttribute('data-id');
	}

	init() {
		super.init();
	}

	initVimeo() {
		this._params.type = 'vimeo';
		this.Player = new Vimeo.Player(this.dom.video, {
			id: this._params.id
		});

		this.Player.ready().then(()=> {
			this.playerReady();
		});
		this.Player.on('ended', this.onEnded.bind(this));
	}

	initYoutube() {

		this._params.type = 'youtube';

		this._YTIsReady = setInterval( function() {
			if( YT.loaded ) {
				clearInterval( this._YTIsReady );

				this.Player = new YT.Player(this.dom.video, {
					height: '100%',
					width: '100%',
					videoId: this._params.id,
					playerVars: {
						'controls': 1,
						'rel': 0,
						'showinfo': 0,
						'modestbranding': 1,
						'origin': 'http://americaribe.bbi.dev.sweetpunk.io'
					},
					events: {
						'onReady': this.playerReady.bind(this)
					}
				});
			}

		}.bind( this ), 100 );
	}

	playerReady() {
		TweenLite.to(this.dom.buttonPlay, 0.5, {autoAlpha: 1});

		// EVENTS / BINDINGS
		this.dom.buttonPlay.addEventListener('click', this.playVideo.bind(this));
		if (this._params.type == 'youtube') {
			this.Player.addEventListener("onStateChange", (state)=> {
				console.log(state.data);
				if(state.data === 0){
					this.onEnded();
				}
			});
		}
	}

	playVideo() {
		TweenLite.to(this.dom.poster, 0.5, {autoAlpha: 0});
		if (ENV.template == 'desktop') {
			TweenLite.to(this.dom.about, 0.5, {autoAlpha: 0, delay: 0.2});
		}

		if (this._params.type == 'youtube') {
			this.Player.playVideo();
		} else if (this._params.type == 'vimeo') {
			this.Player.play();
		}
	}

	onEnded() {
		TweenLite.to(this.dom.poster, 0.5, {autoAlpha: 1});
		TweenLite.to(this.dom.buttonPlay, 0.5, {autoAlpha: 1});
		if (ENV.template == 'desktop') {
			TweenLite.to(this.dom.about, 0.5, {autoAlpha: 1});
		}
	}

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/block-video/block-video.js